module.exports = __webpack_public_path__ + "static/media/ei10.e83a1c46.png";